/* ==========================================================================
   Shared YouTube lazy-load facade — cus-video-lazy.js
   Scans a container for YouTube iframes and replaces each with a
   thumbnail + play button. Click loads the real iframe with autoplay.
   Used by: cus-prod-tabs, cus-blog-post
   ========================================================================== */

(function () {
  "use strict";

  var PLAY_SVG =
    '<svg viewBox="0 0 68 48" width="68" height="48">' +
    '<path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.63-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/>' +
    '<path d="M45 24L27 14v20" fill="#fff"/>' +
    "</svg>";

  /**
   * Extract YouTube video ID from an embed URL.
   * Supports youtube.com/embed/ID and youtube-nocookie.com/embed/ID
   * Returns null if not a YouTube embed.
   */
  function getYouTubeId(src) {
    if (!src) return null;
    var match = src.match(
      /(?:youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9_-]{11})/,
    );
    return match ? match[1] : null;
  }

  /**
   * Build the autoplay embed URL, preserving existing query params.
   */
  function buildAutoplayUrl(originalSrc) {
    var sep = originalSrc.indexOf("?") === -1 ? "?" : "&";
    return originalSrc + sep + "autoplay=1";
  }

  /**
   * Replace YouTube iframes inside `container` with lazy facades.
   * @param {Element} container - DOM element to scan
   */
  function cusVideoLazy(container) {
    if (!container) return;

    var iframes = container.querySelectorAll("iframe");
    iframes.forEach(function (iframe) {
      var src = iframe.getAttribute("src") || "";
      var videoId = getYouTubeId(src);
      if (!videoId) return;

      // Skip if already wrapped in a lazy facade
      if (
        iframe.parentNode.classList &&
        iframe.parentNode.classList.contains("cus-video-lazy")
      )
        return;

      // Read original dimensions for aspect-ratio
      var w = parseInt(iframe.getAttribute("width"), 10);
      var h = parseInt(iframe.getAttribute("height"), 10);

      // Create facade container
      var facade = document.createElement("div");
      facade.className = "cus-video-lazy";
      facade.setAttribute("data-embed-url", buildAutoplayUrl(src));

      if (w > 0 && h > 0) {
        facade.style.aspectRatio = w + " / " + h;
        facade.style.maxWidth = w + "px";
      }

      // Thumbnail (YouTube hqdefault)
      var thumb = document.createElement("img");
      thumb.className = "cus-video-lazy__thumb";
      thumb.src =
        "https://img.youtube.com/vi/" + videoId + "/hqdefault.jpg";
      thumb.alt = "Video thumbnail";
      thumb.loading = "lazy";
      facade.appendChild(thumb);

      // Play button
      var playBtn = document.createElement("button");
      playBtn.className = "cus-video-lazy__play";
      playBtn.setAttribute("aria-label", "Play video");
      playBtn.innerHTML = PLAY_SVG;
      facade.appendChild(playBtn);

      // Replace iframe with facade
      iframe.parentNode.insertBefore(facade, iframe);
      iframe.remove();
    });

    // Event delegation: click on any facade within container
    container.addEventListener("click", function (e) {
      var playBtn = e.target.closest(".cus-video-lazy__play");
      var thumb = e.target.closest(".cus-video-lazy__thumb");
      var facadeEl = e.target.closest(".cus-video-lazy");
      if (
        !facadeEl ||
        facadeEl.classList.contains("cus-video-lazy--active")
      )
        return;
      if (!playBtn && !thumb && e.target !== facadeEl) return;

      var embedUrl = facadeEl.getAttribute("data-embed-url");
      if (!embedUrl) return;

      var newIframe = document.createElement("iframe");
      newIframe.src = embedUrl;
      newIframe.allow =
        "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
      newIframe.allowFullscreen = true;
      facadeEl.appendChild(newIframe);
      facadeEl.classList.add("cus-video-lazy--active");
    });
  }

  // Expose globally
  window.cusVideoLazy = cusVideoLazy;
})();
